module.exports = __webpack_public_path__ + "media/application/images/svgs/arrow-right-circle-2701f05029fdc10c24539b0f3161c771.svg";